import * as React from 'react'
import { Button, Tooltip } from 'react-bootstrap'
import { OverlayTrigger } from 'react-bootstrap'

type Props = {
  onClick(): void
  disabled: boolean
  downTimesLoaded: boolean
}

export class AddNewDownTimeButton extends React.Component<Props> {
  renderButton = (): JSX.Element => (
    <Button
    onClick={this.props.onClick}
    disabled={this.props.disabled}
    >
      Add
    </Button>
  )

  renderDisabledButton = (): JSX.Element => (
      <div>
          <Button
            disabled={this.props.disabled}
            style={{ pointerEvents: 'none' }}
          >
           Add
          </Button>
      </div>
  )

  toolTipText = (): string => {
      if (!this.props.disabled) {
          return 'Add New DownTime';
      } else if (this.props.disabled && this.props.downTimesLoaded) {
          return 'Save or cancel current to create another';
      } else {
        return 'Load DownTimes to add a new one';
      }
  }

  render(): JSX.Element {
      return(
          <OverlayTrigger
            placement={'top'}
            overlay={
                <Tooltip id={'add-new-downtime-tool-tip'}>
                    {this.toolTipText()}
                </Tooltip>
            }
          >
          {this.props.disabled ? this.renderDisabledButton() : this.renderButton()}
          </OverlayTrigger>
      );
  }
}
